import flatpickr from 'flatpickr';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import 'flatpickr/dist/flatpickr.css';

flatpickr.localize(Korean);
